import React, { useEffect, useRef } from "react";

interface DocumentFillProps {
  percentage?: number;
}

const DocumentFill: React.FC<DocumentFillProps> = ({ percentage = 0 }) => {
  const fillRef = useRef<SVGRectElement>(null);

  // Ensure percentage is between 0 and 100
  const clampedPercentage = Math.max(0, Math.min(100, percentage));

  useEffect(() => {
    if (fillRef.current) {
      fillRef.current.style.transform = `translateY(${100 - clampedPercentage}%)`;
    }
  }, [clampedPercentage]);

  return (
    <div className="relative h-full w-full">
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 117 157"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid meet"
      >
        <defs>
          <mask
            id="shape-mask"
            style={{ maskType: "alpha" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="117"
            height="157"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 20C0 14.8283 2.05446 9.86838 5.71142 6.21142C9.36838 2.55446 14.3283 0.5 19.5 0.5H64.2135C69.3848 0.501104 74.3439 2.55629 78 6.2135L111.286 39.5C114.944 43.1561 116.999 48.1152 117 53.2865V137C117 142.172 114.946 147.132 111.289 150.789C107.632 154.446 102.672 156.5 97.5 156.5H19.5C14.3283 156.5 9.36838 154.446 5.71142 150.789C2.05446 147.132 0 142.172 0 137V20Z"
              fill="white"
            />
          </mask>
          <linearGradient
            id="skeleton-gradient"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="0%"
          >
            <stop offset="0%" stopColor="hsla(0, 0%, 100%, 0)" />
            <stop offset="50%" stopColor="hsla(0, 0%, 100%, 0.3)" />
            <stop offset="100%" stopColor="hsla(0, 0%, 100%, 0)" />
          </linearGradient>
          <linearGradient
            id="blue-skeleton-gradient"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="0%"
          >
            <stop offset="0%" stopColor="hsla(220, 79%, 60%, 0)" />
            <stop offset="50%" stopColor="hsla(220, 79%, 60%, 0.3)" />
            <stop offset="100%" stopColor="hsla(220, 79%, 60%, 0)" />
          </linearGradient>
        </defs>
        <g mask="url(#shape-mask)">
          <rect width="117" height="157" fill="#D1D5DB" />

          <rect width="500" height="157" fill="url(#skeleton-gradient)">
            <animate
              attributeName="x"
              from="-500"
              to="117"
              dur="1.2s"
              repeatCount="indefinite"
            />
          </rect>
          <g
            ref={fillRef}
            style={{
              transition: "transform 0.1s ease-in-out",
              transform: `translateY(100%)`,
            }}
          >
            <rect x="0" y="0" width="117" height="157" fill="#1A56DB" />
            <rect width="500" height="157" fill="url(#blue-skeleton-gradient)">
              <animate
                attributeName="x"
                from="-500"
                to="117"
                dur="1.2s"
                repeatCount="indefinite"
              />
            </rect>
          </g>
        </g>
      </svg>
    </div>
  );
};

export default DocumentFill;
